import { RESET_ALL_STATES } from "../actions/actions";

import {
  LOCATION_REQUEST,
  LOCATION_SUCCESS,
  LOCATION_FAILURE,
} from "../actions/actionTypes";

const initialState = {
  isLoading: false,
  error: null,
  data: null,
};

const locationReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOCATION_REQUEST:
      return { ...state, isLoading: true, error: null };
    case LOCATION_SUCCESS:
      return { ...state, isLoading: false, data: action.payload };
    case LOCATION_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case RESET_ALL_STATES:
      return initialState;
    default:
      return state;
  }
};

export default locationReducer;
